export const CURRENT_YEAR = (new Date()).getFullYear();

type ShipLevels = Record<number, string>;
export const SHIP_LEVELS: ShipLevels = {
  1: 'I',
  2: 'II',
  3: 'III',
  4: 'IV',
  5: 'V',
  6: 'VI',
  7: 'VII',
  8: 'VIII',
  9: 'IX',
  10: 'X',
  11: '★',
};
